import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { useCurrentUser } from "./useCurrentUser";

export function useConnectionNotifications() {
  const { data: user } = useCurrentUser();

  const { data: pendingCount = 0 } = useQuery({
    queryKey: ["connection-notifications", user?.id],
    queryFn: async () => {
      if (!user?.id) return 0;

      const { count, error } = await supabase
        .from("user_connections")
        .select("*", { count: "exact", head: true })
        .eq("recipient_id", user.id)
        .eq("status", "pending");

      if (error) throw error;
      return count || 0;
    },
    enabled: !!user?.id,
    refetchInterval: 30000, // Refetch every 30 seconds
  });

  return {
    pendingCount,
    hasNewRequests: pendingCount > 0,
  };
}
